// src/components/KalkulatorMinuliTopliTekstil.js
import React from 'react';
export default function KalkulatorMinuliTopliTekstil() {
  return (
    <div style={{ maxWidth: '600px', margin: '40px auto', textAlign: 'center' }}>
      <h2>Plata sa minulim radom i toplim obrokom za tekstilnu industriju</h2>
      <p>Kalkulator za tekstilnu industriju još uvijek nije spreman.</p>
    </div>
  );
}
